"use strict";
/**
 * Supplier Payments — shared types
 *
 * The unified line item and per-supplier summary the "próximos pagos" view is built on.
 */
Object.defineProperty(exports, "__esModule", { value: true });
